import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {NbDialogService} from '@nebular/theme';
import {BuildMoneyProject} from '../../../class/lifeproject/build-money-project';

@Component({
  selector: 'app-money-builder-editor',
  templateUrl: './money-builder-editor.component.html',
  styleUrls: ['./money-builder-editor.component.css']
})
export class MoneyBuilderEditorComponent implements OnInit {

  @Input()
  buildMoney: BuildMoneyProject;

  @Output()
  onResult = new EventEmitter();

  errorMsg: string;

  @ViewChild('alertDialog')
  alertDialog: TemplateRef<any>;

  constructor(private dialogService: NbDialogService) {
  }

  ngOnInit() {
  }

  private computeResult() {

    if (!this.buildMoney.otherMoney) {
      this.buildMoney.otherMoney = 0;
    }

    if (this.buildMoney.savedMoney < this.buildMoney.futureValue) {

      const i = this.buildMoney.tax / 100;
      let futureValue = 0;

      if (i > 0) {
        const M = (this.buildMoney.savedMoney + this.buildMoney.otherMoney) * Math.pow((1 + i), this.buildMoney.yearToGoal);
        futureValue = this.buildMoney.futureValue - M;

        this.buildMoney.value = futureValue * i / (Math.pow(1 + i, this.buildMoney.yearToGoal) - 1);
        this.buildMoney.yearCost = this.buildMoney.value;
      } else {
        futureValue = (this.buildMoney.futureValue - this.buildMoney.savedMoney - this.buildMoney.otherMoney);
        this.buildMoney.value = futureValue / this.buildMoney.yearToGoal;
        this.buildMoney.yearCost = this.buildMoney.value;
      }

      this.buildMoney.totalCost = this.buildMoney.futureValue - this.buildMoney.savedMoney;
      this.errorMsg = null;
    } else {
      this.errorMsg = 'Attenzione il capitale richiesto e\' minore delle risorse utilizzate';
    }
  }

  calResult() {

    if (this.buildMoney.assets == null || this.buildMoney.assets.length === 0) {
      this.dialogService.open(this.alertDialog,
        {context: 'Non e\' stata inserita nessuna riserva, la riserva dispobible sara\' 0. Vuoi procedere?'})
        .onClose.subscribe(value => {
        if (value) {
          this.buildMoney.savedMoney = 0;
          this.computeResult();
        }
      });
    } else {
      this.computeResult();
    }
  }

  updateSavedValue(check: boolean) {
    if (!check) {
      this.buildMoney.otherMoney = 0;
    }
  }
}
